module.exports = __webpack_public_path__ + "img/trailerFrontLeftOutline.9bdab16b.svg";